import React, { Component } from "react";
import { connect } from "react-redux";
import { Row, Col } from "antd";


import plantBackgroundImage from "../../assets/images/404-bg.png";
import plantstoreLinkDown from "../../assets/images/con-truck.png";
import plantEmptyTower from "../../assets/images/trkr.png"
import ValidateUser from "../../components/ExpireLink";
import { AuthAction } from "../../store/actions";
class StoreDown extends Component {
    constructor(props) {
        super(props);

    }

    render() {
        const { storeName, getStoreName } = this.props
        return (
            <Row justify="center">
                <Col xs={22} sm={18} md={12} lg={11} xl={24}>
                    <ValidateUser
                        backgroundImage={plantBackgroundImage}
                        ImageWidth="335px"
                        ImageHeight="204px"
                        brokentLinkImage={plantstoreLinkDown}
                        emptyTowerImage={plantEmptyTower}
                        exitsText="  The page you are looking for is under construction"
                        isShowButton={true}
                        onhandleClick={() => {
                            this.props.history.push("/rmx")
                            // getStoreName({ storeName: storeName?.rmx_company_asset?.store_url })
                        }}
                    />
                </Col >
            </Row >
        );
    }
}

function mapStateToProps(storeState) {
    return {
        loader: storeState?.AuthReducer.loader,
        error: storeState?.AuthReducer.error,
        // storeName: storeState?.AuthReducer.storeInfo,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        // getStoreName: (data) => dispatch(AuthAction.getStoreUrlReq(data)),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(StoreDown);
